document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const routeAliases = {
  '/all': '/collections/all',
  '/shop': '/collections/all',
  '/pages/shop': '/collections/all',
  '/learn': '/blogs/news',
  '/pages/learn': '/blogs/news',
  '/contact': '/pages/contact',
  '/pages/ask-anything': '/pages/contact'
};

const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
const aliasedPath = routeAliases[currentPath];

if (aliasedPath && aliasedPath !== window.location.pathname) {
  window.location.replace(`${aliasedPath}${window.location.search}${window.location.hash}`);
}

const selectors = {
  menuToggle: '[data-menu-toggle]',
  mobileMenu: '[data-mobile-menu]',
  faqToggle: '[data-faq-toggle]',
  quantityRoot: '[data-quantity-selector]',
  purchaseRoot: '[data-purchase-toggle]',
  stickyProductBar: '[data-sticky-product-bar]',
  productPurchase: '[data-product-purchase]',
  reveal: '[data-reveal]'
};

document.querySelectorAll(selectors.menuToggle).forEach((button) => {
  const targetId = button.getAttribute('aria-controls');
  const menu = document.getElementById(targetId);

  if (!menu) return;

  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    menu.setAttribute('aria-hidden', String(expanded));
  });
});

document.querySelectorAll('details.faq-item').forEach((detail) => {
  const summary = detail.querySelector('summary');
  if (!summary) return;

  summary.setAttribute('data-faq-toggle', '');
  summary.setAttribute('aria-expanded', String(detail.hasAttribute('open')));

  detail.addEventListener('toggle', () => {
    summary.setAttribute('aria-expanded', String(detail.open));
  });
});

document.querySelectorAll(selectors.quantityRoot).forEach((root) => {
  const input = root.querySelector('input[type="number"]');
  const buttons = root.querySelectorAll('button[data-step]');

  if (!input || !buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const step = Number(button.dataset.step || 0);
      const min = Number(input.min || 1);
      const max = Number(input.max || 999);
      const current = Number(input.value || min);
      const next = Math.min(max, Math.max(min, current + step));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

document.querySelectorAll(selectors.purchaseRoot).forEach((root) => {
  const hiddenInput = root.querySelector('input[name="selling_plan"]');
  const options = root.querySelectorAll('[data-purchase-option]');

  if (!hiddenInput || !options.length) return;

  const syncOptionState = (activeOption) => {
    options.forEach((option) => {
      option.classList.toggle('is-active', option === activeOption);
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = option === activeOption;
    });

    const planId = activeOption.dataset.sellingPlanId || '';
    hiddenInput.value = planId;
  };

  options.forEach((option) => {
    option.addEventListener('click', () => syncOptionState(option));
    option.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => syncOptionState(option));
    });
  });

  const checked = Array.from(options).find((option) => option.querySelector('input[type="radio"]')?.checked) || options[0];
  syncOptionState(checked);
});

const productPurchase = document.querySelector(selectors.productPurchase);
const stickyProductBar = document.querySelector(selectors.stickyProductBar);

if (productPurchase && stickyProductBar && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyProductBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(productPurchase);

  stickyProductBar.querySelectorAll('[data-scroll-to-product]').forEach((button) => {
    button.addEventListener('click', () => {
      productPurchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.18 }
  );

  document.querySelectorAll(selectors.reveal).forEach((element) => {
    revealObserver.observe(element);
  });
}
